import React, { useEffect, useState } from "react";
import { addRemoveFeatureToBranch, hideAndUnHideToBranch, updateBranchSystemAccess } from "../helper/api";
import { isAuthenticated } from "../../../auth";
import Toast from "../../../lib/toast";

const BranchSettings = (props) => {

  const [isContentUploadEnabled,setContentUploadEnabled] = useState(false);
  const [isContentHideEnabled,setContentHideEnabled] = useState(false);
  const [isPlannerHideEnabled,setPlannerHideEnabled] = useState(false);
  const [systemAccess, setSystemAccess] = useState([
       {
        title: "CRM Access",
        code: "crm",
        allowAccess: true
      },
      {
        title: "WorkoutPlus Access",
        code: "wp",
        allowAccess: true
      },
      {
        title: "WorkoutPlus Ads Block",
        code: "wp_ads",
        allowAccess: true
      }
  ]);

  const [currentSystemAccess, setCurrentSystemAccess] = useState([]);

  const {user,token} = isAuthenticated();

  const toggleEnableDisableContentUpload = () => {
    setContentUploadEnabled(!isContentUploadEnabled)
  }

  const AddAndRemoveFeatureToBranch=async ()=>{
    try{
      const payload = {
        branchIDs:[props.branch._id],
        activeFeatureList:['upload_content']
      }
      let response = await addRemoveFeatureToBranch(user._id,token,payload);
      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Not updated, try after sometime"
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Updated successfully"
        })
        toggleEnableDisableContentUpload();
      }
    }catch(error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Not updated, try after sometime"
        })
    }
  }

  const HideAndUnHideWpContentToBranch=async ()=>{
    try{
      const payload = {
        branchIDs:[props.branch._id],
        isWpContentHide:!isContentHideEnabled
      }
      let response = await hideAndUnHideToBranch(user._id,token,payload);
      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Not updated, try after sometime"
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Updated successfully"
        })
        setContentHideEnabled(payload.isWpContentHide);
      }
    }catch(error){
      new Toast({
        type:"error",
        duration:3000,
        message:"Not updated, try after sometime"
      })
    }
  }


  const HideAndUnHideWpPlannerToBranch=async ()=>{
    try{
      const payload = {
        branchIDs:[props.branch._id],
        isWpPlannerHide:!isPlannerHideEnabled
      }
      let response = await hideAndUnHideToBranch(user._id,token,payload);
      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Not updated, try after sometime"
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Updated successfully"
        })
        setPlannerHideEnabled(payload.isWpPlannerHide);
      }
    }catch(error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Not updated, try after sometime"
        })
    }
  }



  const handleSystemAccessType = async (index) => {
  const updated = systemAccess.map((item, i) =>
    i === index
      ? { ...item, allowAccess: !item.allowAccess }
      : item
  );

  const accessCodes = updated
    .filter(item => item.allowAccess)
    .map(item => item.code);

  setSystemAccess(updated);
  setCurrentSystemAccess(accessCodes);

  try {
    const payload = {
      branchIDs: [props.branch._id],
      systemAccess: accessCodes
    };

    const response = await updateBranchSystemAccess(
      user._id,
      token,
      payload
    );

    if (response.error) {
      new Toast({
        type: "error",
        duration: 3000,
        message: "Not updated, try after sometime"
      });
    } else {
      new Toast({
        type: "success",
        duration: 3000,
        message: "Updated successfully"
      });

      // Keep the currently loaded branch data in sync
      if (props.branch?.branchconfig?.length) {
        props.branch.branchconfig[0].systemAccess = accessCodes;
      }
    }
  } catch (error) {
      new Toast({
        type: "error",
        duration: 3000,
        message: "Not updated, try after sometime"
      });
    }
  };


  const updateSystemAccess=async ()=>{
    try{
      const payload = {
        branchIDs:[props.branch._id],
        systemAccess:currentSystemAccess
      }
      let response = await updateBranchSystemAccess(user._id,token,payload);
      if(response.error){
        new Toast({
          type:"error",
          duration:3000,
          message:"Not updated, try after sometime"
        })
      }else{
        new Toast({
          type:"success",
          duration:3000,
          message:"Updated successfully"
        })
        setContentHideEnabled(payload.isWpContentHide);
      }
    }catch(error){
      new Toast({
        type:"error",
        duration:3000,
        message:"Not updated, try after sometime"
      })
    }
  }


  // useEffect(() => {
  //   if (!currentSystemAccess.length) return;
  //   updateSystemAccess();
  // },[currentSystemAccess]);



  useEffect(()=>{

    if(props.branch){
        const savedSystemAccess = props.branch?.branchconfig?.[0]?.systemAccess || [];

        setSystemAccess([
          { title: "CRM Access", code: "crm", allowAccess: savedSystemAccess.includes("crm") },
          { title: "WorkoutPlus Access", code: "wp", allowAccess: savedSystemAccess.includes("wp") },
          { title: "WorkoutPlus Ads Block", code: "wp_ads", allowAccess: savedSystemAccess.includes("wp_ads") }
        ]);

        setCurrentSystemAccess(savedSystemAccess);
    }

    let branch = props.branch;
      if(branch && branch.branchconfig?.length){
        if(branch.branchconfig[0].activeFeatureList && branch.branchconfig[0].activeFeatureList.length && branch.branchconfig[0].activeFeatureList.indexOf('upload_content')!=-1){
          setContentUploadEnabled(true);
        }else{
          setContentUploadEnabled(false);
        }

        if(branch.branchconfig[0].isWpContentHide){
          setContentHideEnabled(true);
        }else{
          setContentHideEnabled(false);
        }


        if(branch.branchconfig[0].isWpPlannerHide){
          setPlannerHideEnabled(true);
        }else{
          setPlannerHideEnabled(false);
        }
      }
  },[props]);


  return(
    <div className={window.innerWidth < 768 ? "w-full h-full" : "modal-test-container d-flex"}>
      <div className={window.innerWidth < 768 ? "w-full h-full" : "appointment-info-modal slideBottomToTop flex-item"}>
        {
          !props.hideHeader && (
            <div className="modal-header space-between bg-blue" style={{background:"var(--darkBlue)", padding:"12px"}}>
              <p className="flex-item fs-18 font-weight-700 color-white">Branch Settings</p>
              <div onClick={()=>props.toggleBranchSettings()} className="d-flex desktop-modal-close-button flex-item" style={{width: "30px", height:"30px", background:"#f9f9f9"}}>
                <svg className="flex-item" width="24" height="24" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M4.9283 3.80866C4.77899 3.66445 4.57901 3.58465 4.37144 3.58646C4.16387 3.58826 3.96531 3.67152 3.81853 3.8183C3.67175 3.96508 3.58849 4.16364 3.58668 4.37121C3.58488 4.57879 3.66468 4.77876 3.80888 4.92807L8.38076 9.49995L3.80809 14.0718C3.73248 14.1449 3.67217 14.2322 3.63068 14.3288C3.58919 14.4254 3.56735 14.5293 3.56644 14.6344C3.56552 14.7395 3.58555 14.8437 3.62536 14.941C3.66516 15.0383 3.72395 15.1267 3.79828 15.2011C3.87261 15.2754 3.961 15.3342 4.0583 15.374C4.15559 15.4138 4.25983 15.4338 4.36495 15.4329C4.47007 15.432 4.57395 15.4101 4.67054 15.3687C4.76712 15.3272 4.85448 15.2669 4.92751 15.1912L9.50018 10.6194L14.0721 15.1912C14.2214 15.3354 14.4213 15.4152 14.6289 15.4134C14.8365 15.4116 15.035 15.3284 15.1818 15.1816C15.3286 15.0348 15.4119 14.8363 15.4137 14.6287C15.4155 14.4211 15.3357 14.2211 15.1915 14.0718L10.6196 9.49995L15.1915 4.92807C15.3357 4.77876 15.4155 4.57879 15.4137 4.37121C15.4119 4.16364 15.3286 3.96508 15.1818 3.8183C15.035 3.67152 14.8365 3.58826 14.6289 3.58646C14.4213 3.58465 14.2214 3.66445 14.0721 3.80866L9.50018 8.38053L4.9283 3.80786V3.80866Z" fill="black" />
                </svg>
              </div>
            </div>
          )
        }

        <div className="d-flex w-full" style={{padding:"12px", justifyContent:"space-between", alignItems:"center"}}>
          <p className="flex-item fs-16 font-weight-700" style={{maxWidth:"70%"}}>Upload Content</p>
          <div onClick={()=>AddAndRemoveFeatureToBranch()} className='toggle-button d-flex' style={{backgroundColor: isContentUploadEnabled && "#B3E28F"}}>
            <div className='toggle-ball flex-item' style={{right: isContentUploadEnabled && 0, left: isContentUploadEnabled && "auto", backgroundColor: isContentUploadEnabled && "#5d883c"}} />
          </div>
        </div>

        <div className="d-flex w-full" style={{padding:"12px", justifyContent:"space-between", alignItems:"center"}}>
          <p className="flex-item fs-16 font-weight-700" style={{maxWidth:"70%"}}>Hide Workoutplus Content</p>
          <div onClick={()=>HideAndUnHideWpContentToBranch()} className='toggle-button d-flex' style={{backgroundColor: isContentHideEnabled && "#B3E28F"}}>
            <div className='toggle-ball flex-item' style={{right: isContentHideEnabled && 0, left: isContentHideEnabled && "auto", backgroundColor: isContentHideEnabled && "#5d883c"}} />
          </div>
        </div>

        <div className="d-flex w-full" style={{padding:"12px", justifyContent:"space-between", alignItems:"center"}}>
          <p className="flex-item fs-16 font-weight-700" style={{maxWidth:"70%"}}>Hide Workoutplus Planner</p>
          <div onClick={()=>HideAndUnHideWpPlannerToBranch()} className='toggle-button d-flex' style={{backgroundColor: isPlannerHideEnabled && "#B3E28F"}}>
            <div className='toggle-ball flex-item' style={{right: isPlannerHideEnabled && 0, left: isPlannerHideEnabled && "auto", backgroundColor: isPlannerHideEnabled && "#5d883c"}} />
          </div>
        </div>

        {
          systemAccess.map((data, index) => {
            return(
              <div className="d-flex w-full" style={{padding:"12px", justifyContent:"space-between", alignItems:"center"}} key={index}>
                <p className="flex-item fs-16 font-weight-700" style={{maxWidth:"70%"}}>{data.title}</p>
                <div onClick={()=>handleSystemAccessType(index)} className='toggle-button d-flex cursor-pointer' style={{backgroundColor: data.allowAccess && "#B3E28F"}}>
                  <div className='toggle-ball flex-item' style={{right: data.allowAccess && 0, left: data.allowAccess && "auto", backgroundColor: data.allowAccess && "#5d883c"}} />
                </div>
              </div>
            )
          })
        }

      </div>
    </div>
  )
}

export default BranchSettings;